import { createFileRoute } from '@tanstack/react-router'
import { RequireSuperadmin } from '@/shared/components'
import { RolesPage } from '@/pages/roles/RolesPage'

export const Route = createFileRoute('/roles')({
  component: () => (
    <RequireSuperadmin>
      <RolesPage />
    </RequireSuperadmin>
  ),
})
